"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowLeft = void 0;
var react_1 = __importDefault(require("react"));
var ArrowLeft = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, react_1.default.createElement("g", {
    transform: "translate(-847.775 -190.075) rotate(180)"
  }, react_1.default.createElement("path", {
    d: "M-861.7-217.6l-14.8-15.8l4.4-4.7l22.6,24l-22.4,24l-4.4-4.7l14.8-15.8H-894v-6.8L-861.7-217.6z"
  })));
};
exports.ArrowLeft = ArrowLeft;